/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateCompanyResponseDataFromJSON, CreateCompanyResponseDataToJSON } from './CreateCompanyResponseData';
export function CreateCompanyResponseFromJSON(json) {
    return CreateCompanyResponseFromJSONTyped(json, false);
}
export function CreateCompanyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : CreateCompanyResponseDataFromJSON(json['data'])
    };
}
export function CreateCompanyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: CreateCompanyResponseDataToJSON(value.data)
    };
}
